export const transSizeToRem = (size: string | number) => {
	if (typeof size === "string" && size.match("rem")) {
		return size;
	}
	return `${size}rem`;
};

/**
 * 根据 画板的宽度和列数量计算单元格的宽度
 * @param contentWidth number  画板宽度, 一般为100%
 * @param gridCol number 横向单元格数量
 * @param gridGap number 单元格间隙
 */
export function getCellWidthByGridM({
	contentWidth = "100%",
	gridCol,
	gridGap,
}: {
	contentWidth?: any;
	gridGap: number;
	gridCol: number;
}): string {
	return `calc((${contentWidth} - ${gridGap * (gridCol - 1)}rem) / ${gridCol})`;
}

export const px2rem = (pxValue?: number, defaultValue: string = "initial") => {
	if (typeof pxValue !== "undefined") {
		return `${Number((pxValue / 16).toFixed(4))}rem`;
	}
	return defaultValue;
};
